import { useEffect } from 'react';

import { Stack } from '@mui/material';

import { ConfirmationModal } from 'src/components/Modals';
import ViewPDFModal from 'src/components/ViewPDFModal';
import { SepaAgreementTable } from 'src/features/finance/sepaDirectDebits/components/SepaAgreementTables/SepaAgreementTable/SepaAgreementTable';
import useSepaAgreement from 'src/features/finance/sepaDirectDebits/hooks/useSepaAgreement';

export type SepaAgreementTablesProps = {
    shouldRefetch: number;
};

export function SepaAgreementTables({ shouldRefetch }: SepaAgreementTablesProps) {
    const {
        merchant,
        partner,
        pdfFile,
        adobeDocumentPdf,
        isPDFModalOpen,
        setIsPDFModalOpen,
        loadingAgreementDocumentPdf,
        isDeleteConfirmModalOpen,
        setIsDeleteConfirmModalOpen,
        handleDeleteSepaMandate,
        handleRemindRecord,
        isRemindConfirmModalOpen,
        setIsRemindConfirmModalOpen,
        remindData,
    } = useSepaAgreement();

    useEffect(() => {
        if (shouldRefetch > 0) {
            merchant?.handleRefetchMerchantData();
            partner?.handleRefetchPartnerData();
        }
        // only want this to run if shouldRefetch updates
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldRefetch]);

    return (
        <>
            <Stack>
                <SepaAgreementTable
                    title="Merchant SEPA Agreements"
                    tableRowData={merchant?.merchantData ?? []}
                    dataTestId="merchant-dd-agreements-table"
                    loadingAgreementDocumentPdf={loadingAgreementDocumentPdf}
                    loadingTableRowData={merchant?.loadingMerchantData}
                    tableColDefs={merchant?.merchantSepaAgreementColumns}
                />
                <SepaAgreementTable
                    title="Partner SEPA Agreements"
                    tableRowData={partner?.partnerData ?? []}
                    dataTestId="partner-dd-agreements-table"
                    loadingAgreementDocumentPdf={loadingAgreementDocumentPdf}
                    loadingTableRowData={partner?.loadingPartnerData}
                    tableColDefs={partner?.partnerSepaAgreementColumns}
                />
            </Stack>
            <ViewPDFModal
                title="View SEPA DD Mandate PDF"
                file={pdfFile}
                fileURL={adobeDocumentPdf?.downloadLink}
                isModalOpen={isPDFModalOpen}
                setIsModalOpen={setIsPDFModalOpen}
            />
            <ConfirmationModal
                isOpen={isDeleteConfirmModalOpen}
                onCancel={() => {
                    setIsDeleteConfirmModalOpen(false);
                }}
                message="Are you sure you want to delete mandate?"
                title="Delete SEPA DD Mandate"
                onConfirm={handleDeleteSepaMandate}
            />
            <ConfirmationModal
                title="Send Reminder re. SEPA DD Mandate?"
                message={`${remindData?.contactName} - (${remindData?.sentToEmail})`}
                isOpen={isRemindConfirmModalOpen}
                onCancel={() => {
                    setIsRemindConfirmModalOpen(false);
                }}
                onConfirm={handleRemindRecord}
            />
        </>
    );
}

export default SepaAgreementTables;
